import Datagent                              from 'datagent';
import {respondData, requestHandle, setYear} from '../utils';
import Fecha                                 from '../utils/type/Fecha';
import {defaults}                            from 'datagent/src/utils';

const {filter, format, getField, awaitTo} = Datagent.Hooks;

export const DateFormat = Fecha.format('YYYY-MM-DD HH:mm:ss');
export const DateParse  = Fecha.parse('YYYY-MM-DD HH:mm:ss');

const name  = 'publicSentiment/list';
const Model = Datagent.Model({
    name,
    fields : {
        'title'               : {type: String, default: ''}, // 标题
        'is_confirm'          : {type: String, default: ''}, // 已读标记  0-未确认 1-收录 2-排除
        'sentiment_new'       : {type: String, default: ''}, // 情感类型 负面"(默认)， "正面"
        'industryId'          : {type: String, default: ''}, // 行业id
        'secondTargetName'    : {type: String, default: ''}, // 舆情类型
        'source'              : {type: String, default: ''}, // 数据来源
        'postTime'            : {type: Fecha, default: ''},  // 年份
        'secondTargetNameList': {type: Array, default: []},
        'targetList': {type: Array, default: []},
        'tag_new': { type: val=>val=='待定'?'':val, default: '' }
    },
    methods: {
        savePublicSentiment (params, opts) {
            const {origin} = defaults(opts);
            return this.remote(origin).put(`/publicSentiment/`, params)
        },
        confirmPublicSentiment (params, opts) {
            const {origin} = defaults(opts);
            return this.remote(origin).put(`/publicSentiment/confirm`, params)
        },
        titlePublicSentiment (params, opts) {
            const {origin} = defaults(opts);
            return this.remote(origin).put(`/publicSentiment/title`, params)
        },
        SearchPublicSentiment (params, opts) {
            const {origin} = defaults(opts);
            return this.remote(origin).get(`/publicSentiment/data`, params)
        },
        monthSentiment(params, opts) {
            const {origin} = defaults(opts);
            return this.remote(origin).get(`/publicSentiment/monthSentiment`, params)
        },
        exportPublicSentiment(params, opts) {
            const { origin } = defaults(opts);
            const { type, ...query } = params;
            return this.remote(origin).get(`/publicSentiment/data/export`, query)
        },
        exportMonthSentiment(params, opts) {
            const { origin } = defaults(opts);
            const { type, ...query } = params;
            return this.remote(origin).get(`/publicSentiment/monthSentiment/export`, query)
        }
    },
    hooks  : {
        ...Datagent.mapSendHook([format()]),
        fetch              : {after: [respondData(), requestHandle(), getField('data', format()), setYear()]},
        SearchPublicSentiment : {after: [respondData(), requestHandle(), getField('data', format())]},
        find               : {after: [respondData(), requestHandle(), format()]},
        monthSentiment : {after: [respondData(), requestHandle()]},
        exportPublicSentiment : {after: [respondData(), requestHandle()]},
        exportMonthSentiment : {after: [respondData(), requestHandle()]}
    }
});

Model.ModelName   = name;
export default Model;
